import { useEffect, useState } from "react"
import styled from "styled-components"
import Cookies from 'js-cookie'
import { Button, FullScreenLoadingCover, TextInput } from "@prosolve/common-components-ui"
import useDataJobs from "../../dataHooks/useDataJobs"

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const FieldName = styled.span`
  font-weight: bold;
`

export default ({
  email: emailParam,
}) => {
  const [email, setEmail] = useState(Cookies.get('email'))

  const { isLoading, fetchSendEmail } = useDataJobs()

  const handleSendEmail = () => {
    if (!emailParam) {
      window.alert('Error: No email details provided')
      return
    }

    if (!email) {
      window.alert('"Email Address" is required')
      return
    }

    const clone = {...emailParam}
    clone.to = email
    fetchSendEmail(clone)
  }

  useEffect(() => {
    //fetch user's email to prepopulate the email field?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container>
      <FieldName>Email Address:</FieldName>
      <TextInput value={email} placeholder='user@email.com' onChange={setEmail} />
      <Button onClick={handleSendEmail}>Send Test Email</Button>
      {isLoading &&
        <FullScreenLoadingCover />
      }
    </Container>
  )
}
